module.exports = __webpack_public_path__ + "media/13_samsung_s10_deducion.57752a70.mp3";